<template>
  <div>
    <!-- 首页内容上方 -->
    <div class="content_title">
      <indexContentTop></indexContentTop>
    </div>
    <div style="overflow: hidden">
      <!-- 首页内容中心 -->
      <div class="content_news">
        <div class="content_loop">
          <a-carousel effect="fade" :dots="false" autoplay :autoplaySpeed="5000">
            <div>
              <video muted autoplay src="../../../static/img/index/video01.mp4" style="width: 100%"></video>
              <div class="content_loop_text_box">
                <div class="content_loop_text_title">邯郸市永年区职教中心-上职业高中 创出彩人生</div>
                <router-link :to="{path: '/synews'}">
                  <div class="contNews_title">
                    <div></div>
                    <div>
                      <div>{{title}}</div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div>
              <video muted autoplay src="../../../static/img/index/video02.mp4" style="width: 100%"></video>
              <div class="content_loop_text_box">
                <div class="content_loop_text_title">邯郸市永年区职教中心-上职业高中 创出彩人生</div>
                <div class="contNews_title">
                  <div></div>
                  <div>
                    <div>{{title}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <video muted autoplay src="../../../static/img/index/video03.mp4" style="width: 100%"></video>
              <div class="content_loop_text_box">
                <div class="content_loop_text_title">邯郸市永年区职教中心-上职业高中 创出彩人生</div>
                <div class="contNews_title">
                  <div></div>
                  <div>
                    <div>{{title}}</div>
                  </div>
                </div>
              </div>
            </div>
          </a-carousel>
        </div>
        <!-- 轮播右边news -->
        <contentNews></contentNews>
      </div>
      <div class="specNav">
        <!-- 中间教育动态 校园动态 -->
        <scDynamic></scDynamic>
        <specilNav></specilNav>
        <!-- 专题导航 -->
      </div>
      <imgLoop></imgLoop>
      <!-- 大图 -->
      <div></div>
      <!-- 校园动态 -->
      <botDynamic></botDynamic>
    </div>
  </div>
</template>

<script>
import contentNews from "./contentNews";
import indexContentTop from "./indexContentTop";
import scDynamic from "./smallComp/scDynamic";
import specilNav from "./smallComp/specilNav";
import imgLoop from "./imgLoop";
import botDynamic from "./smallComp/botDynamic";
import { getScList, postNewsByPage } from "../../api/api";
// import axios from "axios";
export default {
  components: {
    contentNews,
    indexContentTop,
    scDynamic,
    specilNav,
    imgLoop,
    botDynamic
  },
  data() {
    return {
      title:'邯郸市永年区职教中心是一所培养初、中级技能型人才为主的国家级综合中等职业学校。学校创办于1984年，占地面积16.8万平方米（252亩），建筑面积10.2万平方米，教学仪器设备总值2897.71万元。 拥有教学楼、办公楼、实训楼、实验楼、学生公寓、实训基地等现代化的教学设施。'
    };
  },
  methods: {},
  created() {
    getScList().then(res => {
      // //console.log(res);
    });
    postNewsByPage(26467290138211, 1, 5).then(res => {
      // //console.log(res);
    });
  }
};
</script>

<style scoped>
.content_title {
  width: 100%;
  height: 82px;
  line-height: 82px;
  background-color: white;
  padding: 0px 2%;
  font-size: 16px;
  display: flex;
  border-radius: 5px;
  color: #333;
  box-shadow: 0px 0px 20px 0px rgba(0, 91, 176, 0.2);
  position: absolute;
  top: -2.5%;
}
.content_title > div {
  width: 100%;
}
.ant-carousel >>> .slick-slide {
  height: unset;
  line-height: unset;
  text-align: unset;
}
.scpre_loop_content_box {
  height: 170px;
  line-height: 70px;
}
.content_title_text {
  font-size: 24px;
  margin-left: 2%;
}
.content_news {
  display: flex;
  width: 100%;
  margin-top: 6%;
}
.content_loop {
  width: 49%;
}
.clickMore {
  width: 50px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background-color: #1890ff;
  color: white;
  font-weight: bold;
  border-radius: 4px;
}
.contNews_title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  background-color: #f8f8fa;
  color: #333;
  height: 100px;
  width: 100%;
  padding: 5px 12px;
  padding-left: 0;
  line-height: 28px;
}
.content_loop_text_title {
  width: 100%;
  color: #333;
  font-size: 22px;
  padding: 15px 10% 5px 15px;
  background: #f8f8fa;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.contNews_title > div:nth-of-type(2) {
  width: 100%;
  padding: 5px;
  padding-left: 15px;
}
.contNews_title > div:nth-of-type(1) > div:nth-of-type(1) {
  font-size: 22px;
  color: #69686b;
  font-weight: bold;
}
.contNews_title > div:nth-of-type(1) > div:nth-of-type(2) {
  font-size: 12px;
  color: #c5c5c7;
}
.contNews_title > div:nth-of-type(2) > div:nth-of-type(1) {
  width: 98%;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  text-indent: 2em;
  color: #a5a5a7;
}
.specNav {
  display: flex;
  justify-content: space-between;
  padding: 0px 0;
}
.specNav > div {
  width: 49%;
}
.newsTitle {
  font-size: 20px;
  color: #1890ff;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 2px dashed #1890ff;
}
.centerNews {
  display: flex;
  justify-content: space-between;
}
.scMenu {
  display: flex;
  justify-content: space-between;
  margin: 15px auto;
}
.scMenu > img {
  width: 19%;
}
.scpre {
  margin: 15px auto;
  padding: 10px;
}
.scpre_title {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  padding-bottom: 0px;
  margin-bottom: 10px;
  border-bottom: #1890ff 3px solid;
}
.scpre_title > h3 {
  font-size: 30px;
  font-weight: bold;
  color: #1890ff;
}
.scpre_loop_content,
.outLink {
  display: flex !important;
  justify-content: space-between !important;
}
.scpre_loop_content > img {
  width: 19%;
}
.outLink {
  padding: 5px 10px;
}
.outLink > img {
  width: 23%;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/indexComp/indexContent.vue